import { BUTTON_INTERACTION } from "@website-builder/utilities/constants/click-events.js";

const generatePricingComponentsData = (components) =>
	components.map(
		({
			name = "",
			detail = {
				withScholarship: "",
				withoutScholarship: "",
			},
		}) => ({
			name,
			detail: {
				withScholarship: detail.withScholarship,
				withoutScholarship: detail.withoutScholarship,
			},
		}),
	);

// generate pricing options for both with and without scholarship data
export const generatePricingOptions = (options) =>
	options.map(
		({
			cta = null,
			footerText = null,
			badge = "",
			name = "",
			components = [],
			actualPrice = {
				withScholarship: "",
				withoutScholarship: "",
			},
			description = {
				withScholarship: "",
				withoutScholarship: "",
			},
			priceSubtext = {
				withScholarship: {
					value: "",
					position: "",
					struckOff: false,
				},
				withoutScholarship: {
					value: "",
					position: "",
					struckOff: false,
				},
			},
		}) => ({
			cta: cta
				? {
						buttonText: cta?.label,
						link: {
							link: cta?.link,
							target: "_self",
							type: "internal",
						},
						event: BUTTON_INTERACTION.CTA_CLICK,
					}
				: null,
			footerText: footerText ? footerText.value : null,
			name,
			badge,
			actualPrice: {
				withScholarship: actualPrice.withScholarship,
				withoutScholarship: actualPrice.withoutScholarship,
			},
			description: {
				withScholarship: description.withScholarship,
				withoutScholarship: description.withoutScholarship,
			},
			priceSubtext: {
				withScholarship: priceSubtext.withScholarship
					? {
							value: priceSubtext.withScholarship.value,
							struckOff: priceSubtext.withScholarship.struckOff,
							position: priceSubtext.withScholarship.position,
						}
					: null,
				withoutScholarship: priceSubtext.withoutScholarship
					? {
							value: priceSubtext.withoutScholarship.value,
							struckOff: priceSubtext.withoutScholarship.struckOff,
							position: priceSubtext.withoutScholarship.position,
						}
					: null,
			},
			components: generatePricingComponentsData(components),
		}),
	);
